/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBodyScan = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM9 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0zM7.5 9.97C8.272 9.351 9.237 9 10 9h4c.66 0 1.628.19 2.46.788.882.636 1.54 1.686 1.54 3.212v3h-2v-3c0-.874-.342-1.324-.71-1.589a1.983 1.983 0 0 0-.29-.172V22h-2v-4h-2v4H9V11.354a2.649 2.649 0 0 0-.25.177C8.303 11.888 8 12.37 8 13v3H6v-3c0-1.372.697-2.388 1.5-3.03zM11 11v5h2v-5zM2 2h4v2H4v2H2zm20 0h-4v2h2v2h2zM2 22v-4h2v2h2v2zm20 0v-4h-2v2h-2v2z" />
        <path d="M22 15H2v-2h20z" />
      </g>
    </g>
  </Icon>
);
export { SvgBodyScan as BodyScan };
